import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import BuildDay from "./pages/BuildDay";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/buildday" element={<BuildDay />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
